import type { SVGProps } from "react";

export const ArrowDropUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m7 14 5-5 5 5z"
    />
  </svg>
);
